import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 pt-32 pb-20 bg-white shadow-lg">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-4">Terms and Conditions</h2>
          <div className="w-20 h-1 bg-gradient-to-r from-blue-600 to-green-500 mx-auto rounded-full"></div>
        </div>
      
      <div className="prose prose-lg text-gray-700">
         <section className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Introduction</h2>
    <p>
      These Terms and Conditions (“Terms”) govern your access and use of <strong>ecnexus.co</strong>. By using this Website, you agree to these Terms. If you disagree with any part, you must discontinue use immediately.
    </p>
  </section>

  <section className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Services</h2>
    <p>
      This Website offers consulting-related information and services. All services and deliverables offered will be further defined in individual agreements with clients. The Website owner reserves the right to withdraw, modify, or suspend offered services at any time without prior notice.
    </p>
  </section>

  <section className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. User Obligations and Permitted Use</h2>
    <ul className="list-disc pl-6 mt-4 space-y-2">
      <li>Users must not engage in illegal, abusive, fraudulent, or disruptive behavior while interacting with the Website.</li>
      <li>Prohibited behavior includes, but is not limited to: hate speech, bullying, spam, unauthorized access attempts, or actions that compromise the Website’s security.</li>
      <li>The Website owner reserves the right to disable, suspend, or delete user accounts that violate these Terms, with or without notice.</li>
    </ul>
  </section>

  <section className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Intellectual Property</h2>
    <p>
      All Website content—including text, graphics, logos, and downloadable documents—is the property of the Website owner unless otherwise specified. Reproduction or commercial use of materials without express consent is prohibited.
    </p>
  </section>

  <section className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Financial Transactions</h2>
    <p>
      Details of payments, refunds, and other financial matters will be addressed in specific consulting agreements. The Website itself does not directly process payments.
    </p>
  </section>

  <section className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Confidentiality</h2>
    <p>
      Any information exchanged between users and the Website owner within a consulting relationship is confidential unless disclosure is required by law.
    </p>
  </section>

  <section className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Liability for Errors, Downtime, and Content</h2>
    <ul className="list-disc pl-6 mt-4 space-y-2">
      <li>The Website does not guarantee uninterrupted access and is not responsible for any errors in the Website, service interruptions, or consequences arising from reliance on Website content.</li>
      <li>All information is provided “as is.”</li>
    </ul>
  </section>

  <section className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Account Disabling and Deletion</h2>
    <p>
      The Website owner may, at its sole discretion, disable or delete user accounts with or without notice if there is any suspected or actual violation of these Terms.
    </p>
  </section>

  <section className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Third-Party Links</h2>
    <p>
      The Website may contain links to external websites. The owner is not responsible for the content, reliability, or privacy practices of such external sites.
    </p>
  </section>

  <section className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Indemnification</h2>
    <p>
      Users agree to indemnify and hold harmless the Website owner from any claims, damages, or losses resulting from breaches of these Terms or unlawful acts.
    </p>
  </section>

  <section className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Governing Law and Dispute Resolution</h2>
    <p>
      These Terms are governed by the laws of India. Any disputes shall be subject to the jurisdiction of courts at the Website owner’s principal place of business.
    </p>
  </section>

  <section className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-900 mb-4">12. Changes to Terms</h2>
    <p>
      The Website owner may update these Terms at their discretion. Continued use after changes implies acceptance.
    </p>
  </section>

        <div className="mt-12 border-t pt-8">
          <p className="text-sm text-gray-500">
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;